var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAclogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.727 34.553h-2.349c-.155 0-.282-.053-.313-.186l-1.155-3.502c-.032-.133-.156-.16-.313-.16h-5.072c-.156 0-.283.027-.313.16l-1.158 3.502c-.031.133-.156.186-.313.186H6.39c-.222 0-.344-.08-.344-.222a5.42 5.42 0 01.309-.893l5.555-15.414c.03-.133.155-.187.312-.187h1.687c.155 0 .282.054.313.187l5.566 15.484c.118.265.213.54.282.822 0 .144-.124.223-.344.223zm-4.884-6.82l-1.346-4.484c-.062-.222-.313-.955-.376-1.166h-.125a43.397 43.397 0 01-.376 1.193l-1.346 4.35a5.013 5.013 0 00-.223.716c0 .133.125.237.345.237h3.29c.223 0 .345-.107.345-.237a3.543 3.543 0 00-.188-.61zm18.346 5.387c-.876.956-2.222 1.698-4.54 1.698h-.939c-3.444 0-5.635-1.858-5.635-4.51v-8.222c0-2.652 2.191-4.51 5.635-4.51h.94c2.222 0 3.568.688 4.443 1.59.444.479.751.956.751 1.063a.258.258 0 01-.189.238l-1.629.688a1.936 1.936 0 01-.533.187.296.296 0 01-.251-.16 3.01 3.01 0 00-2.597-1.486h-.94c-1.533 0-2.817 1.088-2.817 2.388v8.221c0 1.3 1.284 2.388 2.817 2.388h.94a2.999 2.999 0 002.63-1.537.293.293 0 01.251-.16c.174.042.342.105.5.187l1.66.715c.124.054.189.107.189.187.003.134-.28.584-.686 1.035z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.731 9.813l-8.537-8.541v8.541h8.537z",
    fill: "#F1672A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.366 39.644H.634a.278.278 0 01-.278-.279V.636C.356.48.48.355.634.355h38.732c.154 0 .278.124.278.278v38.732a.278.278 0 01-.278.278zM.912 39.088h38.176V.912H.912v38.176z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.366 40H.634A.635.635 0 010 39.365V.636C0 .284.284 0 .634 0h38.732c.35 0 .635.284.635.634v38.732a.636.636 0 01-.635.634zM1.268 38.732h37.464V1.268H1.268v37.464z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAclogo);
export default __webpack_public_path__ + "static/media/aclogo.45ba5553747acef6725df4af66f22150.svg";
export { ForwardRef as ReactComponent };